import axios from 'axios';
import { toast } from 'vue3-toastify';

// Configuration de base pour axios
const API_BASE_URL =  'https://bookmysalon-967a856b16b6.herokuapp.com/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT à chaque requête
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs d'authentification et d'abonnement
// Intercepteur pour gérer les erreurs d'authentification et d'abonnement
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // 1. On vérifie si la requête qui a échoué était une tentative de connexion
      // Remplace '/auth/login' par le bout d'URL exact de ton endpoint de login si nécessaire
      const isLoginRequest = error.config.url.includes('/auth/login') || error.config.url.includes('/login');

      // Erreur d'authentification (Exclure la page de login pour éviter le reload infini)
      if (error.response.status === 401 && !isLoginRequest) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }

      // Erreur d'abonnement inactif
      if (error.response.status === 403 && error.response.data?.requiresSubscription) {
        toast.error('Abonnement requis. Activez votre abonnement pour accéder à cette fonctionnalité.', {
          position: 'top-right',
          autoClose: 5000
        });

        setTimeout(() => {
          if (window.location.pathname !== '/settings') {
            window.location.href = '/settings';
          }
        }, 2000);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
export { API_BASE_URL };
